export interface RowHeaderTitleProps {
  title?: string;
  onClick?: () => void;
  headingTag?: 'h3' | 'h4';
}

export const RowHeaderTitle = ({ title, onClick, headingTag = 'h3' }: RowHeaderTitleProps) => {
  const Heading = headingTag;
  const content = (
    <Heading className="m-0 truncate text-sm font-semibold text-gray-900" title={title}>
      {title}
    </Heading>
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className="min-w-0 max-w-full cursor-pointer bg-transparent border-none p-0 text-left text-gray-900 hover:text-info-600 transition-colors duration-200"
      >
        {content}
      </button>
    );
  }

  return content;
};
